import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { fromJS, List, Map } from 'immutable';
import { Toggles } from '../../../features-data/sub-models/toggles.model';
import { IFormMasterBuilder } from '../../../form-master/form-master.interface';
import {
  getDefaultReminders,
  PAYMENT_REMINDER_ON_DUE,
  PAYMENT_REMINDER_SEVEN_AFTER,
  PAYMENT_REMINDER_THREE_AFTER,
  PAYMENT_REMINDER_THREE_BEFORE,
} from '../../../payments-data/payments-data.data';
import { CompanySettings } from '../../../settings-data/sub-models/company-settings/company-settings.model';
import { PaymentReminders } from '../../../settings-data/sub-models/company-settings/payment-reminders.model';
import { SettingsContent } from '../../../settings-data/sub-models/settings-content.model';
import { DateTimeService } from 'i2g-ng-utils';

@Injectable()
export class PaymentRemindersBuilder implements IFormMasterBuilder {
  FORM_KEYS = {
    PAYMENT_REMINDERS_ENABLED: 'paymentRemindersEnabled',
    PAYMENT_REMINDER_THREE_BEFORE: 'paymentReminderThreeBefore',
    PAYMENT_REMINDER_ON_DUE: 'paymentReminderOnDue',
    PAYMENT_REMINDER_THREE_AFTER: 'paymentReminderThreeAfter',
    PAYMENT_REMINDER_SEVEN_AFTER: 'paymentReminderSevenAfter',
  };

  constructor(
    private _formBuilder: FormBuilder,
    private _dateTimeService: DateTimeService
  ) {}

  buildForm(
    remindersSettings: PaymentReminders,
    featureToggles: Toggles
  ): FormGroup {
    const formKeys = this.FORM_KEYS;
    const remindIn = remindersSettings.remindIn.isEmpty()
      ? List(getDefaultReminders(featureToggles))
      : remindersSettings.remindIn;
    const enableReminders =
      featureToggles.isAllAccess(Toggles.KEYS.PAYMENT_REMINDERS) &&
      remindersSettings.enabled;

    return this._formBuilder.group({
      [formKeys.PAYMENT_REMINDERS_ENABLED]: [enableReminders],
      [formKeys.PAYMENT_REMINDER_THREE_BEFORE]: [
        {
          value:
            enableReminders && remindIn.includes(PAYMENT_REMINDER_THREE_BEFORE),
          disabled: !enableReminders,
        },
      ],
      [formKeys.PAYMENT_REMINDER_ON_DUE]: [
        {
          value: enableReminders && remindIn.includes(PAYMENT_REMINDER_ON_DUE),
          disabled: !enableReminders,
        },
      ],
      [formKeys.PAYMENT_REMINDER_THREE_AFTER]: [
        {
          value:
            enableReminders && remindIn.includes(PAYMENT_REMINDER_THREE_AFTER),
          disabled: !enableReminders,
        },
      ],
      [formKeys.PAYMENT_REMINDER_SEVEN_AFTER]: [
        {
          value:
            enableReminders && remindIn.includes(PAYMENT_REMINDER_SEVEN_AFTER),
          disabled: !enableReminders,
        },
      ],
    });
  }

  buildSettingsProps(
    enabled: boolean,
    remindIn: List<number>
  ): Map<string, any> {
    return fromJS({
      [SettingsContent.KEYS.COMPANY_SETTINGS]: {
        [CompanySettings.KEYS.PAYMENT_REMINDERS]: {
          [PaymentReminders.KEYS.ENABLED]: enabled,
          [PaymentReminders.KEYS
            .OLSON_TIMEZONE]: this._dateTimeService.getTimezone(),
          [PaymentReminders.KEYS.REMIND_IN]: remindIn,
        },
      },
    });
  }
}
